<template>
  <div class="activate page">
    <AppHeader back_button config_button>{{$root.texts.section_activate_app.title}}</AppHeader>
    <div class="activate__content">
      <div class="activate__title">{{$root.texts.section_activate_app.text_title}}</div>
      <div class="activate__text" v-html="$root.texts.section_activate_app.text"></div>
      <input
        class="text-input activate__text-input"
        type="tel"
        autocomplete="off"
        autocorrect="off"
        autofocus
        v-model.number="code"
        v-on:keyup="keymonitor"
        :placeholder="$root.texts.section_activate_app.input_code_hint"
      >
      <div
        class="activate__text activate__error"
        v-if="showErrorMessage"
      >Wrong code, please, try again.</div>
      <button
        :class="{'btn':true, 'activate__button':true, 'btn-disabled':isButtonDisabled }"
        @click="activate"
      >{{$root.texts.section_activate_app.button}}</button>
    </div>
  </div>
</template>

<script>
import AppHeader from "@/components/AppHeader.vue";

export default {
  name: "activate",
  data() {
    return {
      code: null,
      isButtonDisabled: true,
      showErrorMessage: false
    };
  },
  watch: {
    code: function(val) {
      if (val == null || val == "" || val.length == 0) {
        this.isButtonDisabled = true;
        this.showErrorMessage = false;
      } else {
        this.isButtonDisabled = false;
      }
    }
  },
  methods: {
    keymonitor: function(e) {
      if (e.key == "Enter") this.activate();
    },
    activate: function() {
      if (this.code == atob("MTE3Njk=")) {
        this.$root.validated = true;
        this.showErrorMessage = false;
        this.$router.push({ name: "protected" });
        //} else {
        //  this.showErrorMessage = true;
      }
    }
  },
  components: {
    AppHeader
  }
};
</script>